<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">
                {{ meta.title }}
            </div>
            <div :class="fieldValueClass">
                <ai-select-box-clearable
                    v-model:value="value"
                    :data-source="dataSource"
                    :disabled="disabled"
                    :display-expr="meta.extParams.displayExpr"
                    :showClearButton="meta.showClearButton || false"
                    :value-expr="meta.extParams.valueExpr"
                    @opened="onOpenHandler"
                    @valueChanged="valueChanged"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, inject, onBeforeMount, ref } from 'vue';
import AiSelectBoxClearable from '@/components/ai-select-box-clearable.vue';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';

const props = defineProps({
    ds: {
        type: Array,
        default: () => [],
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    callbacks: {
        type: Object,
        default: () => ({
            userDataChanged: null,
            getDictionary: null,
        }),
    },
    meta: {
        type: Object,
        default: () => {},
    },
});

const serverData = inject('serverData');
const userData = inject('userData');
const dataSource = ref(props.ds);

const onOpenHandler = async () => {
    await getDictionaryHandler();
};

onBeforeMount(async () => {
    if (props.meta.extParams) {
        const initialDS = [
            {
                [`${props.meta.extParams.valueExpr}`]: userData?.value[props.meta.fieldNameText],
                [`${props.meta.extParams.displayExpr}`]: userData?.value[props.meta.fieldNameId],
            },
        ];
        if (dataSource.value.length === 0 && serverData?.value.length !== 0 && initialDS) {
            dataSource.value = initialDS;
        }
    }
});

const getDictionaryHandler = async () => {
    switch (props.meta.extParams.entitySelection) {
        case 'contract':
            dataSource.value = new DataSource({
                store: new ArrayStore({
                    data: [
                        {
                            id: 1,
                            text: 'Список договоров',
                        },
                        {
                            id: 2,
                            text: 'Набор параметров',
                        },
                    ],
                    key: 'id',
                }),
            });
            break;
        case 'object':
            dataSource.value = new DataSource({
                store: new ArrayStore({
                    data: [
                        {
                            id: 1,
                            text: 'Список объектов',
                        },
                        {
                            id: 2,
                            text: 'Набор параметров',
                        },
                    ],
                    key: 'id',
                }),
            });
            break;
        case 'meteringPoint':
            dataSource.value = new DataSource({
                store: new ArrayStore({
                    data: [
                        {
                            id: 1,
                            text: 'По состоянию на дату печати',
                        },
                        {
                            id: 2,
                            text: 'Набор параметров',
                        },
                    ],
                    key: 'id',
                }),
            });
            break;
        case 'contractSigned':
            dataSource.value = new DataSource({
                store: new ArrayStore({
                    data: [
                        {
                            id: 1,
                            text: 'Сотрудник',
                        },
                        {
                            id: 2,
                            text: 'Сотрудник с должностной функцией',
                        },
                    ],
                    key: 'id',
                }),
            });
            break;
        case 'annexForm':
            dataSource.value = new DataSource({
                store: new ArrayStore({
                    data: [
                        {
                            id: 1,
                            text: 'Полная',
                        },
                        {
                            id: 2,
                            text: 'Сокращённая',
                        },
                    ],
                    key: 'id',
                }),
            });
            break;
        case 'printWhere':
            dataSource.value = new DataSource({
                store: new ArrayStore({
                    data: [
                        {
                            id: 1,
                            text: 'В файловой системе',
                        },
                        {
                            id: 2,
                            text: 'Выводить на принтер',
                        },
                    ],
                    key: 'id',
                }),
            });
            break;
        default:
            return {
                result: false,
                uuid: '6ea1c733-a7d3-414a-b551-9984c69eabaa',
                msg: 'entitySelection name error',
            };
    }
};

const valueChanged = e => {
    userDataChange(e.value, e.text);
};

const userDataChange = (value, text) => {
    userData.value[props.meta.fieldNameText] = value;
    if (text) {
        userData.value[props.meta.fieldNameId] = text;
    }
    props.callbacks.userDataChanged();
};

const value = computed(() => {
    if (userData.value[props.meta.fieldNameText] === undefined) {
        return null;
    }
    return userData.value[props.meta.fieldNameText];
});

const fieldValueClass = computed(() => {
    return {
        'dx-field-value': true,
    };
});
</script>
